import React from "react";
import { Button } from "web/react/emo/button";
import { Heading } from "web/react/emo/heading";
import { Modal } from "web/react/emo/modal";
import { VerifiedBadge } from "web/react/emo/verified-badge/verified-badge";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./storefront-modal.css";

interface StorefrontInfoModalProps {
    title: string;
    isOpen: boolean;
    onCtaClick?: () => void;
    onClose: () => void;
    children: React.ReactNode;
    showCheckoutVerifiedBadge?: boolean;
    storeFrontURL?: string;
}

export function StorefrontModal({
    title,
    isOpen,
    onClose,
    onCtaClick,
    children,
    storeFrontURL,
    showCheckoutVerifiedBadge = false,
}: StorefrontInfoModalProps): React.ReactElement {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <View className={styles.container} dataTestId="storefront-modal">
                <View className={styles.titleSection} marginBottom="sm">
                    <Heading textStyle="subhead">{title}</Heading>
                    {showCheckoutVerifiedBadge && <VerifiedBadge size="sm" />}
                </View>
                <View marginBottom="sm" className={styles.divider} />
                <View
                    marginBottom={storeFrontURL ? "sm" : "none"}
                    className={styles.contentContainer}
                >
                    {children}
                </View>
                {storeFrontURL && (
                    <View marginTop="xs">
                        <Button
                            width="full"
                            href={storeFrontURL}
                            title={gettext("storefront.modal.button.visit_full_store")}
                            onClick={onCtaClick}
                        />
                    </View>
                )}
            </View>
        </Modal>
    );
}
